import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Burger Builder" link="https://myburgermaker.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a react based application where you can add/remove ingredients dynamically and order your self-built burger. Real-Time Firebase database has been used for backend.
    </ProjectCard>
    <ProjectCard title="Tell Me This" link="https://tellmethis.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a react based qusetion-answer game that gives your report in the end.
    </ProjectCard>
    <ProjectCard title="Youtube Clone" link="https://myyoutubeclone.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This a react project uses youtube-API for sending and receiving data asynchronously. It displays the video searched for.
    </ProjectCard>
    <ProjectCard title="Book-List" link="https://bookread.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This project uses local-strorage to retain book-data even after a refresh. This has been built using context-api and react-hooks.
    </ProjectCard>
    <ProjectCard title="Movie Magic" link="https://moviemagicsearch.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This project uses movie-API for sending and receiving data asynchronously as per the movie searched. 
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      